module.exports = __webpack_public_path__ + "fonts/avenir/0b86525a-9c26-4c1d-9abe-c05fd31ecf2e.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/avenir/0b86525a-9c26-4c1d-9abe-c05fd31ecf2e.woff
// module id = 44
// module chunks = 0